import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import styles from './styles.module.scss';
import CookieFunction from '../../functions/cookieFunction';
// import { Helmet } from 'react-helmet';
// import SeoHead from '../SeoHead';

const Main = ({ children, className = '', onClick }) => {
  const { themeColor, themeMode, content } = useContext(AdminContext);

  return (
    <div
      className={`${styles.wholeContainer} ${
        themeMode != 'dark' ? styles.containerWhite : styles.containerDark
      } mode_${themeMode}`}
    >
      {/* <Helmet>
        <SeoHead content={content} />
      </Helmet> */}
      <div
        className={`${
          styles.container
        }${` `}${className} ${`theme_${themeColor} ${
          CookieFunction('get', 'ochattToken') != undefined &&
          CookieFunction('get', 'ochattToken') &&
          styles.paddingTop
        }`} ${
          themeMode != 'dark' ? styles.containerWhite : styles.containerDark
        }`}
        onClick={onClick}
      >
        {/* <button onClick={notificationFunction}>notification</button> */}
        {children}
      </div>
    </div>
  );
};

export default Main;
